import { render, staticRenderFns } from "./PatientShow.vue?vue&type=template&id=1c83f5c2&scoped=true"
import script from "./PatientShow.vue?vue&type=script&lang=js"
export * from "./PatientShow.vue?vue&type=script&lang=js"
import style0 from "./PatientShow.vue?vue&type=style&index=0&id=1c83f5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c83f5c2",
  null
  
)

export default component.exports